import React from "react";
import { useTranslation } from "react-i18next";
import { AMLFormModal } from "@features/AMLModal/components/AMLFormModal/AMLFormModal";
import { Button } from "@components/Button";
import { BanknotesIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { useModalStore, type IUseModalProps } from "@store/modal/modal";
import {
  useCitizenshipsQuery,
  useDefaultCitizenshipsCountryQuery,
} from "@services/citizenships/queries";

interface IAMLModalProps extends IUseModalProps {
  onFormSubmit?: () => void;
}

export const AMLModal: React.FC<IAMLModalProps> = ({
  onFormSubmit,
  ...modalProps
}) => {
  const { t } = useTranslation();
  const modal = useModal(modalProps);
  const { create } = useModalStore();
  const { isLoading: isCitizenshipsLoading } = useCitizenshipsQuery();
  const { isLoading: isDefaultCitizenshipsLoadingCountry } =
    useDefaultCitizenshipsCountryQuery();
  const isLoading =
    isCitizenshipsLoading || isDefaultCitizenshipsLoadingCountry;

  const proceedToForm = (isDefaultCountry = true) => {
    create((modalProps) => (
      <AMLFormModal
        {...modalProps}
        isDefaultCountry={isDefaultCountry}
        onFormSubmit={() => {
          modal.close();
          onFormSubmit?.();
        }}
      />
    ));
  };

  return (
    <Modal
      modal={modal}
      badgeProps={{ icon: BanknotesIcon }}
      title={t("AMLModal.title")}
      subtitle={t("AMLModal.subtitle")}
    >
      <div className="flex flex-col gap-4">
        <Button
          className="w-full"
          isLoading={isLoading}
          onClick={() => proceedToForm(true)}
        >
          {t("AMLModal.actions.local")}
        </Button>
        <Button
          className="w-full"
          variant="secondary"
          isLoading={isLoading}
          onClick={() => proceedToForm(false)}
        >
          {t("AMLModal.actions.foreigner")}
        </Button>
        <p className="text-sm text-grey-dark">{t("AMLModal.note")}</p>
      </div>
    </Modal>
  );
};
